<template lang="html">
  <v-container fluid>
    <public-cancel-booking
      style="max-width: 500px;"
      class="mx-auto"
      :calendarId="calendarId"
      :eventId="eventId"
    ></public-cancel-booking>
  </v-container>
</template>

<script>
import {PublicCancelBooking} from 'dync-booking';

export default {
  props: {
    calendarId: {},
    eventId: {}
  },
  components: {
    PublicCancelBooking
  }
}
</script>

<style lang="css" scoped>
</style>
